import { Calendar } from "@tamagui/lucide-icons";
import { Timestamp } from "firebase/firestore";
import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";
import type { ModalProps } from "react-native";
import {
  FormDataModal,
  FormSheetType,
  type FormValues,
} from "../../core/components/FormDataModal";
import { getDayJsDate } from "../../core/dayJs";
import type BaseModuleModel from "../core/BaseModuleModel";
import type { ModuleModelData, Snapshot } from "../core/BaseModuleModel";

type BaseModuleWithDates = BaseModuleModel<Snapshot, ModuleModelData<Snapshot>>;

export const DueDateModal: React.FC<
  ModalProps & {
    initialDueDate: Timestamp;
    onClose: () => void;
    module: BaseModuleWithDates;
    onSave: ({ dueDate }: { dueDate: Timestamp }) => void;
  }
> = observer(({ module, initialDueDate, onSave, ...props }) => {
  const onSaveAction = React.useCallback(
    async (data: FormValues) => {
      // Set only updated values
      onSave({
        dueDate: Timestamp.fromDate(new Date(data.dueDate as string)),
      });
    },
    [onSave],
  );

  return (
    <FormDataModal
      {...props}
      title={"Set dates"}
      buttonSaveText={"Save event"}
      values={useMemo(
        () => ({
          dueDate:
            getDayJsDate(
              initialDueDate,
              module.plan.data.settings.dateFormat,
            ) ?? "",
        }),
        [initialDueDate, module.plan.data.settings.dateFormat],
      )}
      form={[
        {
          formKey: "dueDate",
          label: "Due date",
          type: FormSheetType.Date,
          icon: Calendar,
          required: true,
          placeholder: "Set due date...",
          plan: module.plan, // for settings
        },
      ]}
      onSave={onSaveAction}
    />
  );
});
